export const JUDGE_FACTORY_ROUTE_PATTERN =
  'workspaces/:workspaceName/judge-factory-gen/:judgeId?';

export function getJudgeFactoryPath(
  workspaceName: string,
  judgeId?: string | null,
): string {
  const basePath = `/workspaces/${encodeURIComponent(
    workspaceName,
  )}/judge-factory-gen`;
  return judgeId ? `${basePath}/${encodeURIComponent(judgeId)}` : basePath;
}
